import React from 'react'
import Select from 'react-select'
import PropTypes from 'prop-types'

const CustomSelect = ({ placeholder, options, setSelectedValue, formatOptionLabel, selected }) => (
  <Select
    styles={{
      menu: (styles) => ({ ...styles, zIndex: 2 }),
      control: (styles) => ({
        ...styles,
        border: 'unset',
        cursor: 'pointer',
        '&:hover': {
          borderColor: 'unset',
        },
      }),
      indicatorSeparator: () => ({ display: 'none' }),
    }}
    isSearchable={false}
    placeholder={placeholder}
    formatOptionLabel={formatOptionLabel}
    options={options}
    onChange={({ value }) => {
      if (value !== selected) {
        setSelectedValue(value)
      }
    }}
  />
)

CustomSelect.propTypes = {
  placeholder: PropTypes.object.isRequired,
  options: PropTypes.array.isRequired,
  setSelectedValue: PropTypes.func.isRequired,
  formatOptionLabel: PropTypes.func.isRequired,
  selected: PropTypes.any.isRequired,
}

export default CustomSelect
